import React from "react";
import FaqsContent from "../../Components/PrivacyAndPolicy/faqs-content";
import UserDataContent from "../../Components/PrivacyAndPolicy/user-data";
import TermsAndConditions from "../../Components/PrivacyAndPolicy/terms-and-conditions";
import PrivacyPolicyPage from "../../pages/Legals/PrivacyPolicy";

const UserData = () =>{
    return (
        <UserDataContent />
    )
}

const PrivacyPolicy = () => {
  return (
      <PrivacyPolicyPage />
  );
};

const Faqs = () => {
  return <FaqsContent />;
};

const TermsAndCondition = () => {
  return <TermsAndConditions/>;
};


export { UserData, PrivacyPolicy, Faqs, TermsAndCondition };
